var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg70(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "33px",
    viewBox: "0 0 26 33",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7029 10.5656C30.7029 10.5656 30.5138 10.5656 30.5138 10.5656L0.638167 1.88672C0.0709075 1.69805 -0.118179 1.13203 0.0709075 0.754689C0.259994 0.188672 0.827254 0 1.20543 0L31.0811 8.67893C31.6484 8.8676 31.8375 9.43361 31.6484 9.81096C31.6484 10.377 31.0811 10.5656 30.7029 10.5656Z",
    transform: "matrix(-0.50000006 0.8660254 -0.8660254 -0.50000006 25.009766 5.282837)",
    id: "Path",
    fill: "#000000",
    fillOpacity: 0.8662807,
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg70);
export default __webpack_public_path__ + "static/media/70.35b2573164a0a413c3222f4a36c017d3.svg";
export { ForwardRef as ReactComponent };